var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('quillEditor',{staticClass:"roma-editor",attrs:{"content":_vm.description,"options":_vm.editorOption},on:{"change":function($event){return _vm.onEditorChange($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }